var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99684 1.85651C7.10919 1.70379 7.20186 1.56755 7.30459 1.43956C9.07329 -0.75889 12.3327 -0.375343 13.5576 2.17585C14.2889 3.69875 14.0699 5.1531 13.2214 6.55713C12.5001 7.75072 11.5283 8.72564 10.4748 9.6255C9.48989 10.4663 8.43549 11.2139 7.33082 11.8929C7.09607 12.0374 6.89979 12.0348 6.66548 11.8903C4.79449 10.734 3.04545 9.43155 1.61554 7.74855C0.899494 6.90596 0.313278 5.98571 0.082464 4.88627C-0.324521 2.94468 0.801136 0.68852 2.88021 0.121444C4.30925 -0.268176 5.87337 0.299334 6.77433 1.54195C6.84558 1.64001 6.91422 1.73937 6.99684 1.85651Z",
    fill: "#4A5981"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.bef7a6c40541a8bd8bb83b16ab870338.svg";
export { ForwardRef as ReactComponent };